export const ID = 'id';
export const NAME = 'name';
export const DESCRIPTION = 'description';

export const APPLICATIONS = 'applications';
export const INTERNAL_TAGS = 'internalTags';
export const HAS_STATS = 'hasStats';

export const UPDATED_BY = 'updatedBy';
export const UPDATED_DATE = 'updatedDate';
export const CREATED_BY = 'createdBy';
export const CREATED_DATE = 'createdDate';

export const CREATIVES_COUNT = 'creativesCount';
export const CONCEPTS_COUNT = 'conceptsCount';

export const ORIGINAL = 'original';
export const ORIGINAL_CONCEPT_ID = 'originalConceptId';

export const ACTIONS = 'actions';
